import { render, staticRenderFns } from "./SelectCurrency.vue?vue&type=template&id=2577eb40&"
import script from "./SelectCurrency.vue?vue&type=script&lang=ts&"
export * from "./SelectCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports